import React, { useRef } from 'react';
import AlignmentBars from './AlignmentBars';
import JawShapeQuestion from './JawShapeQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';

function Questionnaire({
  capturedImage,
  questions,
  currentQuestion,
  answers,
  chinPosition,
  widowsPeakPosition,
  leftFacePosition,
  rightFacePosition,
  isDraggingChin,
  isDraggingWidowsPeak,
  isDraggingLeftFace,
  isDraggingRightFace,
  setIsDraggingChin,
  setIsDraggingWidowsPeak,
  setIsDraggingLeftFace,
  setIsDraggingRightFace,
  handleMouseMove,
  handleTouchMove,
  stopDragging,
  handleAnswerChange,
  prevQuestion,
  nextQuestion,
  handleSubmit,
  imageRef,
  imageContainerRef
}) {
  const question = questions[currentQuestion];

  return (
    <div 
      className="bg-white rounded-lg shadow-xl p-8"
      onMouseMove={(e) => handleMouseMove(e, imageContainerRef)}
      onMouseUp={stopDragging}
      onTouchMove={(e) => handleTouchMove(e, imageContainerRef)}
      onTouchEnd={stopDragging}
    >
      <div className="mb-4 text-center">
        <span className="text-sm text-gray-500">
          Question {currentQuestion + 1} of {questions.length}
        </span>
      </div>
      
      <div 
        ref={imageContainerRef}
        className="mb-4 relative"
        style={{ userSelect: 'none' }}
      >
        <img
          ref={imageRef}
          src={capturedImage}
          alt="Reference"
          className="w-full max-h-96 object-contain rounded-lg shadow-md"
          draggable="false"
        />
        
        <AlignmentBars
          type={question.type}
          chinPosition={chinPosition}
          widowsPeakPosition={widowsPeakPosition}
          leftFacePosition={leftFacePosition}
          rightFacePosition={rightFacePosition}
          setIsDraggingChin={setIsDraggingChin}
          setIsDraggingWidowsPeak={setIsDraggingWidowsPeak}
          setIsDraggingLeftFace={setIsDraggingLeftFace}
          setIsDraggingRightFace={setIsDraggingRightFace}
        />
      </div>

      <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        {question.text}
      </h1>

      {question.type === 'jaw-shape' && (
        <JawShapeQuestion
          answer={answers[question.id]}
          onAnswerChange={handleAnswerChange}
          questionId={question.id}
        />
      )}

      {question.type === 'multiple-choice' && (
        <MultipleChoiceQuestion
          options={question.options}
          answer={answers[question.id]}
          onAnswerChange={handleAnswerChange}
          questionId={question.id}
        />
      )}

      {question.type !== 'horizontal-alignment' && 
       question.type !== 'vertical-alignment' && 
       question.type !== 'jaw-shape' && 
       question.type !== 'multiple-choice' && (
        <div className="mb-6">
          {question.type === 'textarea' ? (
            <textarea
              value={answers[question.id] || ''}
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              rows="4"
              placeholder="Type your answer here..."
            />
          ) : (
            <input
              type="text"
              value={answers[question.id] || ''}
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Type your answer here..."
            />
          )}
        </div>
      )}

      <div className="flex gap-4">
        {currentQuestion > 0 && (
          <button
            onClick={prevQuestion}
            className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
          >
            ← Previous
          </button>
        )}
        
        {currentQuestion < questions.length - 1 ? (
          <button
            onClick={nextQuestion}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
          >
            Next →
          </button>
        ) : (
          <button
            onClick={handleSubmit}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
          >
            Submit ✓
          </button>
        )}
      </div>
    </div>
  );
}

export default Questionnaire;
